<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <div class="grid_row mt-4">
        <v-card class="upload_width">
          <div class="pa-6">
            <v-file-input color="#86bc3a" accept="image/*" label="เพิ่มรูปภาพ" v-model="pro_pic_name" @change="onFileChange"></v-file-input>
            <div class="ml-4">
              <v-img height="400" max-width="400" v-if="imagePreviewURL" :src="imagePreviewURL" class="preview mx-auto"></v-img>
            </div>
            <div class="mt-6">
              <v-btn x-large v-if="imagePreviewURL" class="btn_btn white--text grad-success-bg" @click="createImg()">อัพโหลด</v-btn>
            </div>
          </div>
        </v-card>
        <v-card class="img_show">
          <div class="ma-2">
            <v-card-title>
              <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="ImgHeaders" :items="ImgList" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.id }}</td>
                  <td>
                    <v-img height="100" max-width="100" class="preview ma-2" :src="dataDetail.item.cover_img_path"></v-img>
                  </td>
                  <td>
                    <v-switch color="#86bc3a" @change="changeStatus(dataDetail.item.status)" v-model="dataDetail.item.status"></v-switch>
                  </td>
                  <td>
                    <v-btn small height="42" @click="delAlert(dataDetail.item.id)" class="grad-danger-bg white--text mb-1">
                      <v-icon>mdi-delete-empty-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </div>

    </div>
  </div>
</template>

<script src="@/previewimage.js"></script><script>
import { HTTP } from '@/axios.js';
import Swal from 'sweetalert2'
export default {
  name: "ManageAbout",
  data() {
    return {
      pro_pic_name: null,
      imagePreviewURL: null,
      loading_page: false,
      search: '',
      alert_success: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      ImgHeaders: [
        {
          text: 'ลำดับ',
          value: '',
          fixed: true,
          width: '200px',
        },
        {
          text: 'รูปภาพ',
          value: '',
          fixed: true,
          width: '350px',
        },
        {
          text: 'สถานะ',
          value: '',
          fixed: true,
          width: '250px',
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          width: '200px',
          sortable: false,
        },
      ],
      ImgList: [],
    }
  },
  methods: {
    onFileChange(payload) {
      const file = payload
      if (file) {
        this.imagePreviewURL = URL.createObjectURL(file)
        URL.revokeObjectURL(file)
      } else {
        this.imagePreviewURL = null
      }
      // console.log(this.pro_pic_name)
    },
    delAlert(id) {
      // console.log(id)
      Swal.fire({
        title: 'คุณต้องลบข้อมูลหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((result) => {
        if (result.isConfirmed) {
          // Swal.fire('ลบข้อมูลเรียบร้อย', '', 'success');
          this.getDelete(id)
        }
      });
    },
    successUpload() {
      Swal.fire('อัพโหลดไฟล์รูปเรียบร้อย', '', 'success')
          .then(() => {
            //Do something.
            this.getImage();
          })
    },
    createImg() {
      let config = {
        header : {
          'Content-Type' : 'multipart/form-data'
        }
      };
      const fd = new FormData();
      fd.append('img', this.pro_pic_name, this.pro_pic_name.name);
      HTTP.post("/manage-website/coverimage/create", fd, config)
          .then((res) => {
            if (res.data.success === true) {
              this.imagePreviewURL = null;
              this.pro_pic_name = null;
              this.successUpload();
            }
          })
    },
    getImage() {
      HTTP.post('/manage-website/coverimage/all')
          .then((res) => {
            if (res.data.success === true){
              this.ImgList = res.data.object;
              // console.log(res.data.object);
              // console.log(res.data.object.status);
            }
          })
    },
    getDelete(id) {
      HTTP.post('/manage-website/coverimage/delete', {
        id: id
      }).then((res) => {
        if (res.data.success === true) {
          Swal.fire('ลบข้อมูลเรียบร้อย', '', 'success');
          this.getImage();
        }
      })
    },
    changeStatus(status) {
      console.log(status)
      this.alert_success = true;
      setTimeout(() => this.alert_success = false, 1000);
    },
  },
  mounted() {
    this.getImage();
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
.grid_row {
  display: grid;
  grid-template-columns: 40% 60%;
  grid-gap: 15px 0;
}
.upload_width{
  width: 95%;
}
.img_show {
  width: 100%;
}
.preview {
  border-radius: 8px;
}
.btn_btn {
  width: 100%;
  font-size: 18px;
}
@media only screen and (max-width: 1100px) {
  .grid_row {
    display: grid;
    grid-template-columns: 100%;
  }
  .upload_width{
    width: 100%;
  }
}
</style>
